export default __webpack_public_path__ + "static/media/crodudes_logo_1.0d317e8f.png";